import { useEffect } from "react";
import { useLocation } from "react-router";
import posthog, { isPostHogReady } from "../analytics/posthogClient";

/** Route pageviews → PostHog only. */
const PathTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isPostHogReady()) {
      posthog.capture("$pageview", { pathname });
    }
  }, [pathname]);

  return null;
};

export default PathTracker;
